module.exports = {
	"version": "2.5.29"
};


/*****************
 ** WEBPACK FOOTER
 ** ./version.json
 ** module id = 235
 ** module chunks = 0
 **/